export default "__VITE_ASSET__DCabq$Kl__"